import { MedicalAidPick, medicalAidFields } from 'src/app/core/scheme-reference/scheme-pick';

/** What the link dialog saves: the medical aid picked (or typed when not listed) and the member details typed. */
export function linkMedicalDetailsPayload(
  form: { medicalMainMember?: string; medicalAidNumber?: string; medicalDependantCode?: string; gapCover?: string; gapCoverNumber?: string },
  pick: MedicalAidPick | null,
) {
  const text = (value: string | undefined) => (value ?? '').trim();
  return {
    ...(pick ? medicalAidFields(pick) : {}),
    medicalMainMember: text(form.medicalMainMember),
    medicalAidNumber: text(form.medicalAidNumber),
    medicalDependantCode: text(form.medicalDependantCode),
    gapCover: text(form.gapCover),
    gapCoverNumber: text(form.gapCoverNumber),
  };
}
